export default "__VITE_ASSET__B$IAeHpV__"